import { defineMessage } from 'services/localization';

export const messages = {
    label: defineMessage('no_access_to_connect_the_accounting_system'),
    labelInvite: defineMessage('invite_your_teammate_to_connect'),
    buttonInvite: defineMessage('invite_teammate'),
};
